import { render, staticRenderFns } from "./From.vue?vue&type=template&id=45b2dc83&"
import script from "./From.vue?vue&type=script&lang=js&"
export * from "./From.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports